const welcomePage = () => import(/* webpackChunkName: "welcomePage" */ '@/pages/welcome-page')

// Authentication
const lobbyContainer = () => import(/* webpackChunkName: "lobbyContainer" */ '@/components/lobby-container')
const loginCABPPage = () => import(/* webpackChunkName: "loginPage" */ '@/pages/login/login-cabp')
const loginKeycloakPage = () => import(/* webpackChunkName: "loginKeycloakPage" */ '@/pages/login/login-keycloak')
const loginKeycloakCallbackPage = () => import(/* webpackChunkName: "loginKeycloakCallbackPage" */ '@/pages/login/login-keycloak-callback')
const smsVerification = () => import(/* webpackChunkName: "smsVerification" */ '@/pages/sms-verification')
const loginDefaultPage = () => import(/* webpackChunkName: "loginPage" */ '@/pages/login/login-default')
const loginCabpAuth = () => import(/* webpackChunkName: "loginCabpAuth" */ '@/pages/login/login-cabp-auth')
const cgu = () => import(/* webpackChunkName: "cgu" */ '@/pages/cgu')
const registerPage = () => import(/* webpackChunkName: "registerPage" */ '@/pages/register.vue')

// Client
const authenticatedPage = () => import(/* webpackChunkName: "authenticatedPage" */ '@/pages/authenticated/index')
const dashboardPage = () => import(/* webpackChunkName: "dashboardPage" */ '@/pages/dashboard')
const holdingsDashboard = () => import(/* webpackChunkName: "holdingsDashboard" */ '@/pages/dashboard/holdings/page-holdings-dashboard')
const dashboardContracts = () => import(/* webpackChunkName: "dashboardContracts" */ '@/pages/dashboard/dashboard-contracts')
const loansDashboard = () => import(/* webpackChunkName: "loansDashboard" */ '@/pages/dashboard/loans/page-loans-dashboard')
const adviceDiscoverLanding = () => import(/* webpackChunkName: "adviceDiscoverLanding" */ '@/pages/dashboard/advice/discover-landing')
const adviceDashboard = () => import(/* webpackChunkName: "adviceDashboard" */ '@/pages/dashboard/advice/page-advice-dashboard')
const dashboardLoansContracts = () => import(/* webpackChunkName: "dashboardLoansContracts" */ '@/pages/dashboard/dashboard-loans-contracts')
const advisorAppointmentScheduling = () => import(/* webpackChunkName: "advisorAppointmentScheduling" */ '@/pages/dashboard/advice/advisor-appointment-scheduling')

// advice part
const advisedManagement = () => import(/* webpackChunkName: "AdvisedManagement" */ '@/pages/dashboard/advice/sections/advised-management')
const arbitration = () => import(/* webpackChunkName: "arbitration" */ '@/pages/dashboard/advice/sections/arbitration')

const contractPage = () => import(/* webpackChunkName: "contractPage" */ '@/pages/contract')
const contractOverview = () => import(/* webpackChunkName: "contractOverview" */ '@/pages/contract/contract-overview')
const contractProject = () => import(/* webpackChunkName: "contractProject" */ '@/pages/contract/contract-project')
const contractAllocation = () => import(/* webpackChunkName: "contractAllocation" */ '@/pages/contract/contract-allocation')
const contractInvestments = () => import(/* webpackChunkName: "contractInvestments" */ '@/pages/contract/contract-investments')
const contractSettings = () => import(/* webpackChunkName: "contractSettings" */ '@/pages/contract/contract-settings')
const contractMyProduct = () => import(/* webpackChunkName: "contractMyProduct" */ '@/pages/contract/contract-my-product')
const contractPerformance = () => import(/* webpackChunkName: "contractPerformance" */ '@/pages/contract/contract-performance')
const contractDetails = () => import(/* webpackChunkName: "contractDetails" */ '@/pages/contract/contract-details')
const contractDocuments = () => import(/* webpackChunkName: "contractDocuments" */ '@/pages/contract/contract-documents')
const contractInformations = () => import(/* webpackChunkName: "contractInformations" */ '@/pages/contract/contract-informations')
const contractInfoNeeded = () => import(/* webpackChunkName: "contractInfoNeeded" */ '@/pages/contract/contract-info-needed')
const realestatePage = () => import(/* webpackChunkName: "realestatePage" */ '@/pages/real-estate')
const realEstateFormAddNew = () => import(/* webpackChunkName: "realEstateAddForm" */ '@/pages/accounts/real-estate/form-add-new.vue')
const realEstateEvaluate = () => import(/* webpackChunkName: "realEstateEvaluate" */ '@/pages/accounts/real-estate/evaluate.vue')
const realEstateSettings = () => import(/* webpackChunkName: "realEstateSettings" */ '@/pages/contract/realestate/realestate-settings.vue')

const fundOverview = () => import(/* webpackChunkName: "fundOverviewfunds" */ '@/pages/contract/funds/fund-overview.vue')
const fundInvestment = () => import(/* webpackChunkName: "fundInvestment" */ '@/pages/contract/funds/fund-investment.vue')
const fundTransaction = () => import(/* webpackChunkName: "fundTransaction" */ '@/pages/contract/funds/fund-transaction.vue')

const analysePage = () => import(/* webpackChunkName: "analysePage" */ '@/pages/analyse')
const analyseAllocation = () => import(/* webpackChunkName: "analyseAllocation" */ '@/pages/analyse/analyse-allocation')
const analysePerf = () => import(/* webpackChunkName: "analysePerf" */ '@/pages/analyse/analyse-perf')
const analyseRisk = () => import(/* webpackChunkName: "analyseRisk" */ '@/pages/analyse/analyse-risk')
const analyseFees = () => import(/* webpackChunkName: "analyseFees" */ '@/pages/analyse/analyse-fees')
const analyseAdvices = () => import(/* webpackChunkName: "analyseAdvices" */ '@/pages/analyse/analyse-advices')

const arbitrationPage = () => import(/* webpackChunkName: "arbitrationPage" */ '@/pages/arbitration')
const arbitrationStart = () => import(/* webpackChunkName: "arbitrationStart" */ '@/pages/arbitration/arbitration-start')
const arbitrationMarket = () => import(/* webpackChunkName: "arbitrationMarket" */ '@/pages/arbitration/arbitration-market')
const arbitrationOptimize = () => import(/* webpackChunkName: "arbitrationOptimize" */ '@/pages/arbitration/arbitration-optimize')
const arbitrationDetails = () => import(/* webpackChunkName: "arbitrationDetails" */ '@/pages/dashboard/advice/arbitration-details')

const userPage = () => import(/* webpackChunkName: "userPage" */ '@/pages/user.vue')
const userProfile = () => import(/* webpackChunkName: "userProfile" */ '@/pages/user/user-profile')
const userHoldings = () => import(/* webpackChunkName: "userHoldings" */ '@/pages/user/user-holdings')
const userDocuments = () => import(/* webpackChunkName: "userDocuments" */ '@/pages/user/user-documents')
const userAllDocuments = () => import(/* webpackChunkName: "userAllDocuments" */ '@/pages/user/documents/user-all-documents')
const userAllArbitrations = () => import(/* webpackChunkName: "userAllArbitrations" */ '@/pages/user/documents/user-all-arbitrations')
const userAllManagementReport = () => import(/* webpackChunkName: "userAllManagementReport" */ '@/pages/user/documents/user-all-management-report')
const userAllCgu = () => import(/* webpackChunkName: "userAllCgu" */ '@/pages/user/documents/user-all-cgu')
const userAdvisor = () => import(/* webpackChunkName: "userAdvisor" */ '@/pages/user/user-advisor')
const userNotifications = () => import(/* webpackChunkName: "userNotifications" */ '@/pages/user/user-notifications')
const deleteProfile = () => import(/* webpackChunkName: "deleteProfile" */ '@/pages/delete-profile')

const subscriptionPage = () => import(/* webpackChunkName: "subscriptionPage" */ '@/pages/subscription.vue')
const paymentPage = () => import(/* webpackChunkName: "paymentPage" */ '@/pages/payment.vue')

const accountsAdd = () => import(/* webpackChunkName: "accountsAdd" */ '@/pages/accounts/add.vue')
const accountsAddIndex = () => import(/* webpackChunkName: "accountsAddIndex" */ '@/pages/accounts/add/index.vue')
const accountsAddForm = () => import(/* webpackChunkName: "accountsAddForm" */ '@/pages/accounts/add/form-bank-add.vue')
const accountsAddWebView = () => import(/* webpackChunkName: "accountsAddWebView" */ '@/pages/accounts/add/accounts-add-webview.vue')
const accountWebauthRedirect = () => import(/* webpackChunkName: "accountWebauthRedirect" */ '@/pages/accounts/add/AccountWebauthRedirect.vue')
const accountsNewList = () => import(/* webpackChunkName: "accountsNewList" */ '@/pages/accounts/add/accounts-list.vue')
const accountsUpdateCredentials = () => import(/* webpackChunkName: "accountsUpdateCredentials" */ '@/pages/accounts/update/credentials.vue')
const accountsLoad = () => import(/* webpackChunkName: "accountsLoad" */ '@/pages/accounts/load.vue')

const profileFill = () => import(/* webpackChunkName: "profileFill" */ '@/pages/accounts/profile')
const profileFillRisk = () => import(/* webpackChunkName: "profileFillRisk" */ '@/pages/accounts/profile/questions')
const profileFillInfos = () => import(/* webpackChunkName: "profileFillInfos" */ '@/pages/accounts/profile/infos')
const profileResult = () => import(/* webpackChunkName: "profileResult" */ '@/pages/accounts/profile/result')

const accountsRisk = () => import(/* webpackChunkName: "accountsRisk" */ '@/pages/accounts/risk')

// Club
const clubLayout = () => import(/* webpackChunkName: "clubLayout" */ '@/pages/club/ClubLayout')
const ClubLanding = () => import(/* webpackChunkName: "ClubLanding" */ '@/pages/club/ClubLanding')
const clubPriceSelection = () => import(/* webpackChunkName: "clubPriceSelection" */ '@/pages/club/ClubPriceSelection')
const clubSubscription = () => import(/* webpackChunkName: "clubSubscription" */ '@/pages/club/ClubSubscription')
const clubDashboard = () => import(/* webpackChunkName: "clubDashboard" */ '@/pages/club/ClubDashboard')
const ClubPortfolios = () => import(/* webpackChunkName: "ClubPortfolios" */ '@/pages/club/ClubPortfolios')
const ClubSettings = () => import(/* webpackChunkName: "ClubSettings" */ '@/pages/club/ClubSettings')
const ClubUnsubscribe = () => import(/* webpackChunkName: "ClubUnsubscribe" */ '@/pages/club/ClubUnsubscribe')
const ClubExitSurvey = () => import(/* webpackChunkName: "ClubExitSurvey" */ '@/pages/club/ClubExitSurvey')
const ClubPortfoliosSelection = () => import(/* webpackChunkName: "ClubPortfoliosSelection" */ '@/pages/club/ClubPortfoliosSelection')
const ClubPaymentInfos = () => import(/* webpackChunkName: "ClubPaymentInfos" */ '@/pages/club/ClubPaymentInfos')
const ClubWaitingAdvisor = () => import(/* webpackChunkName: "ClubWaitingAdvisor" */ '@/pages/club/ClubWaitingAdvisor')

// Advisor
const advisoryPage = () => import(/* webpackChunkName: "advisoryPage" */ '@/pages/advisory/index')
const advisoryArbitrationPdf = () => import(/* webpackChunkName: "advisoryArbitrationPdf" */ '@/pages/advisory/allocation/arbitration-pdf')
const advisoryArbitrationPerformanceCalculation = () => import(/* webpackChunkName: "advisoryArbitrationPerformanceCalculation" */ '@/pages/advisory/allocation/performance-calculation')
const advisoryArbitrationPdfPreview = () => import(/* webpackChunkName: "advisoryArbitrationPdfPreview" */ '@/pages/advisory/allocation/arbitration-pdf-preview')

const advisoryCustomers = () => import(/* webpackChunkName: "advisoryCustomers" */ '@/pages/advisory/advisory-customers')
const advisoryCustomersList = () => import(/* webpackChunkName: "advisoryCustomersList" */ '@/pages/advisory/customers-list')
const advisoryCustomersAdd = () => import(/* webpackChunkName: "advisoryCustomersAdd" */ '@/pages/advisory/customers-add')
const advisoryCustomerInfos = () => import(/* webpackChunkName: "advisoryCustomerInfos" */ '@/pages/advisory/customer-infos')
const customerOverview = () => import(/* webpackChunkName: "customerOverview" */ '@/pages/advisory/customer/overview')
const customerCompliance = () => import(/* webpackChunkName: "customerCompliance" */ '@/pages/advisory/customer/customer-compliance')
const customerArbitrations = () => import(/* webpackChunkName: "customerArbitrations" */ '@/pages/advisory/arbitrations/customer-arbitrations')
const customerPerformances = () => import(/* webpackChunkName: "customerPerformances" */ '@/pages/advisory/customer/customer-performances')

// Conpliance tabs
const complianceOverview = () => import(/* webpackChunkName: "complianceOverview" */ '@/pages/advisory/customer/compliance/overview')
const complianceRisk = () => import(/* webpackChunkName: "complianceRisk" */ '@/pages/advisory/customer/compliance/risk')
const complianceEsg = () => import(/* webpackChunkName: "complianceEsg" */ '@/pages/advisory/customer/compliance/esg')
const complianceDocuments = () => import(/* webpackChunkName: "complianceDocuments" */ '@/pages/advisory/customer/compliance/documents')

// Advisory stats
const advisoryStatsLayout = () => import(/* webpackChunkName: "advisoryStatsLayout" */ '@/pages/dashboard/advice/sections/stats/stats-layout')
const advisoryStatsDashboard = () => import(/* webpackChunkName: "advisoryStatsDashboard" */ '@/pages/dashboard/advice/sections/stats/stats-dashboard')

// advisory esg-setting
const advisoryEsgSettings = () => import(/* webpackChunkName: "advisoryEsgSettings" */ '@/pages/advisory/advisory-esg-settings')

// advisory arbitrations
const advisoryArbitrations = () => import(/* webpackChunkName: "advisoryArbitrations" */ '@/pages/advisory/advisory-arbitrations')

// advisory product customer arbitrations
const advisoryProductCustomerArbitrations = () => import(/* webpackChunkName: "advisoryProductCustomerArbitrations" */ '@/pages/advisory/advisory-product-customer-arbitrations')

// advisory collective arbitration list
const advisoryCollectiveArbitrationList = () => import(/* webpackChunkName: "advisoryCollectiveArbitrationList" */ '@/pages/advisory/advisory-collective-arbitration-list')

// advisory collective arbitration history
const advisoryCollectiveArbitrationHistory = () => import(/* webpackChunkName: "advisoryCollectiveArbitrationHistory" */ '@/pages/advisory/advisory-collective-arbitration-history')

// advisory support
const advisorySupport = () => import(/* webpackChunkName: "advisorySupport" */ '@/pages/advisory/advisory-support')

// product customer
const productCustomerDetails = () => import(/* webpackChunkName: "productCustomerDetails" */ '@/pages/advisory/product-customer-arbitrations/product-customer-details')
const productCustomerCustomer = () => import(/* webpackChunkName: "productCustomerCustomer" */ '@/pages/advisory/product-customer-arbitrations/product-customer-customer')
const productCustomerInvest = () => import(/* webpackChunkName: "productCustomerInvest" */ '@/pages/advisory/product-customer-arbitrations/product-customer-invest')
const productCustomerRepartition = () => import(/* webpackChunkName: "productCustomerRepartition" */ '@/pages/advisory/product-customer-arbitrations/product-customer-repartition')
const productCustomerEsg = () => import(/* webpackChunkName: "productCustomerEsg" */ '@/pages/advisory/product-customer-arbitrations/product-customer-esg')
const productCustomerUnivers = () => import(/* webpackChunkName: "productCustomerUnivers" */ '@/pages/advisory/product-customer-arbitrations/product-customer-univers')

// customer contract allocation
const customerAllocationSteps = () => import(/* webpackChunkName: "customerAllocationSteps" */ '@/pages/advisory/allocation/customer-allocation-steps')
const customerContractAllocation = () => import(/* webpackChunkName: "customerContractAllocation" */ '@/pages/advisory/allocation/customer-contract-allocation')
const customerVerificationAllocation = () => import(/* webpackChunkName: "customerContractAllocation" */ '@/pages/advisory/allocation/customer-verification')
const customerAllocationFund = () => import(/* webpackChunkName: "customerAllocationFund" */ '@/pages/advisory/allocation/customer-allocation-fund') 
const customerAllocationRecomendation = () => import(/* webpackChunkName: "customerAllocationRecomendation" */ '@/pages/advisory/allocation/customer-allocation-recommendation')
const customerAllocationRecomendationFundsListModification = () => import(/* webpackChunkName: "customerAllocationRecomendationFundsListModification" */ '@/pages/advisory/allocation/funds-list-modification')
const customerAllocationRecomendationSummary = () => import(/* webpackChunkName: "customerAllocationRecomendationSummary" */ '@/pages/advisory/allocation/customer-allocation-recommendation-summary')
const customerAllocationFees = () => import(/* webpackChunkName: "customerAllocationFees" */ '@/pages/advisory/allocation/customer-allocation-fees')

const customerStockExchangeSteps = () => import(/* webpackChunkName: "customerStockExchangeSteps" */ '@/pages/advisory/stock-exchange/analyse-steps')
const customerStockExchangeAllocation = () => import(/* webpackChunkName: "customerStockExchangeAllocation" */ '@/pages/advisory/stock-exchange/current-allocation')
const customerStockExchangeAnalysis = () => import(/* webpackChunkName: "customerStockExchangeAnalysis" */ '@/pages/advisory/stock-exchange/analysis')
const customerStockExchangeTargetPortfolio = () => import(/* webpackChunkName: "customerStockExchangeTargetPortfolio" */ '@/pages/advisory/stock-exchange/target-portfolio')
const customerStockExchangePortfolioPerformance = () => import(/* webpackChunkName: "customerStockExchangePortfolioPerformance" */ '@/pages/advisory/allocation/performance-calculation')

// customer estate allocation
const customerEstateSteps = () => import(/* webpackChunkName: "customerEstateSteps" */ '@/pages/advisory/estate/customer-estate-steps')
const customerDefinitionAvailableSavings = () => import(/* webpackChunkName: "customerDefinitionAvailableSavings" */ '@/pages/advisory/estate/customer-definition-available-savings')
const customerInterEnvelopeReallocation = () => import(/* webpackChunkName: "customerInterEnvelopeReallocation" */ '@/pages/advisory/estate/customer-inter-envelope-reallocation')
const customerEstateFees = () => import(/* webpackChunkName: "customerEstateFees" */ '@/pages/advisory/estate/fees')
const customerIntraEnvelopeReallocation = () => import(/* webpackChunkName: "customerIntraEnvelopeReallocation" */ '@/pages/advisory/estate/customer-intra-envelope-reallocation')
const customerArbitrationListReallocation = () => import(/* webpackChunkName: "customerArbitrationListReallocation" */ '@/pages/advisory/estate/arbitration-list-reallocation')
const customerEstateReportPreview = () => import(/* webpackChunkName: "customerEstateReportPreview" */ '@/pages/advisory/estate/customer-estate-report-preview')
const customerEstateReportPdf = () => import(/* webpackChunkName: "customerEstateReportPdf" */ '@/pages/advisory/estate/customer-estate-report-pdf')

const customerInteractions = () => import(/* webpackChunkName: "customerInteractions" */ '@/pages/advisory/customer/customer-interactions')

const customerMissions = () => import( '@/pages/advisory/customer/customer-missions')
const advisoryMissionsLayout = () => import(/* webpackChunkName: "advisoryMissionsLayout" */ '@/pages/advisory/missions/missions-layout')
const advisoryMissionsFinancials = () => import(/* webpackChunkName: "advisoryMissionsFinancials" */ '@/pages/advisory/missions/missions-financials')
const advisoryMissionsWizard = () => import(/* webpackChunkName: "advisoryMissionsWizard" */ '@/pages/advisory/missions/missions-wizard')
const advisoryMissionsDetails = () => import(/* webpackChunkName: "advisoryMissionsDetails" */ '@/pages/advisory/missions/missions-details')

const customerClub = () => import(/* webpackChunkName: "customerMissions" */ '@/pages/advisory/customer/club/ClubIndex')

const fundPage = () => import(/* webpackChunkName: "fundPage" */ '@/pages/fund')

const loading = () => import(/* webpackChunkName: "loading" */ '@/pages/loading')

// multi-arbitration
const multiArbitrationOnefundPage = () => import(/* webpackChunkName: "multiArbitrationOnefundPage" */ '@/pages/multi-arbitration/multi-arbitration-one-fund')
const multiArbitrationConvergencePage = () => import(/* webpackChunkName: "multiArbitrationConvergencePage" */ '@/pages/multi-arbitration/multi-arbitration-convergence')
const multiArbitrationStep = () => import(/* webpackChunkName: "multiArbitrationStep" */ '@/pages/multi-arbitration/multi-arbitration-steps')
const multiArbitrationModelPortfolio = () => import(/* webpackChunkName: "multiArbitrationModelPortfolio" */ '@/pages/advisory/multi-arbitration-steps/select-model-portfolio')
const multiArbitrationModelPortfolioInvestment = () => import(/* webpackChunkName: "multiArbitrationModelPortfolioInvestment" */ '@/pages/advisory/multi-arbitration-steps/select-model-portfolio-tabs/investment')
const multiArbitrationModelPortfolioRepartition = () => import(/* webpackChunkName: "multiArbitrationModelPortfolioRepartition" */ '@/pages/advisory/multi-arbitration-steps/select-model-portfolio-tabs/repartition')
const multiArbitrationModelPortfolioBacktest = () => import(/* webpackChunkName: "multiArbitrationModelPortfolioBacktest" */ '@/pages/advisory/multi-arbitration-steps/select-model-portfolio-tabs/backtest')
const multiArbitrationModelPortfolioESG = () => import(/* webpackChunkName: "multiArbitrationModelPortfolioESG" */ '@/pages/advisory/multi-arbitration-steps/select-model-portfolio-tabs/esg')
const multiArbitrationDisinvestStep = () => import(/* webpackChunkName: "multiArbitrationDisinvestStep" */ '@/pages/advisory/multi-arbitration-steps/disinvest')
const multiArbitrationInvestStep = () => import(/* webpackChunkName: "multiArbitrationInvestStep" */ '@/pages/advisory/multi-arbitration-steps/invest')
const multiArbitrationContractStep = () => import(/* webpackChunkName: "multiArbitrationContractArbitrationStep" */ '@/pages/advisory/multi-arbitration-steps/contract-arbitration')
const multiArbitrationComplianceStep = () => import(/* webpackChunkName: "multiArbitrationCustomerComplianceStep" */ '@/pages/advisory/multi-arbitration-steps/customer-compliance')
const multiArbitrationVerificationStep = () => import(/* webpackChunkName: "multiArbitrationDataVerificationStep" */ '@/pages/advisory/multi-arbitration-steps/data-verification')
const multiArbitrationFeesStep = () => import(/* webpackChunkName: "multiArbitrationFeesStep" */ '@/pages/advisory/multi-arbitration-steps/fees')
const contractOrders = () => import(/* webpackChunkName: "contractOrders" */ '@/pages/advisory/multi-arbitration-steps/contract-arbitration-tabs/contract-orders')
const contractJustifications = () => import(/* webpackChunkName: "contractJustifications" */ '@/pages/advisory/multi-arbitration-steps/contract-arbitration-tabs/contract-justifications')
const multiArbitrationPerimeterArbitrated = () => import(/* webpackChunkName: "perimeterArbitrated" */ '@/pages/advisory/multi-arbitration-steps/compliance-tabs/perimeter-arbitrated')
const multiArbitrationOutPerimeter = () => import(/* webpackChunkName: "outPerimeter" */ '@/pages/advisory/multi-arbitration-steps/compliance-tabs/out-perimeter')

// portfolio-builder
const portfolioBuilderPage = () => import( /* webpackChunkName: "portfolioBuilderPage" */ '@/pages/portfolio-builder/index')
const portfolioBuilderContracts = () => import( /* webpackChunkName: "portfolioBuilderContracts" */ '@/pages/portfolio-builder/contracts/index')
const portfolioBuilderProductDetails = () => import( /* webpackChunkName: "portfolioBuilderProductDetails" */ '@/pages/portfolio-builder/contracts/product-details')
const portfolioBuilderProductFondsUniverse = () => import( /* webpackChunkName: "portfolioBuilderProductFondsUniverse" */ '@/pages/portfolio-builder/contracts/funds-universe')
const portfolioBuilderProductModelPortfolios = () => import( /* webpackChunkName: "portfolioBuilderProductModelPortfolios" */ '@/pages/portfolio-builder/contracts/product-model-portfolios')
const portfolioBuilderModelPortfolioPdf = () => import( /* webpackChunkName: "portfolioBuilderModelPortfolioPdf" */ '@/pages/portfolio-builder/contracts/pdf/model-portfolio-pdf')

//portfolio-editor
const portfolioEditor = () => import( /* webpackChunkName: "portfolioEditor" */ '@/pages/portfolio-builder/editor/index')
const portfolioEditorStepPortfolio = () => import( /* webpackChunkName: "portfolioEditorStepPortfolio" */ '@/pages/portfolio-builder/editor/steps/portfolio')
const portfolioEditorStepConfirmation = () => import( /* webpackChunkName: "portfolioEditorStepConfirmation" */ '@/pages/portfolio-builder/editor/steps/confirmation')
const portfolioEditorModelPortfolio = () => import( /* webpackChunkName: "portfolioEditorModelPortfolio" */ '@/pages/portfolio-builder/editor/steps/tabs/model-portfolio')
const portfolioEditorAllocation = () => import( /* webpackChunkName: "portfolioEditorAllocation" */ '@/pages/portfolio-builder/editor/steps/tabs/allocation')
const portfolioEditorEsg = () => import( /* webpackChunkName: "portfolioEditorEsg" */ '@/pages/portfolio-builder/editor/steps/tabs/esg')
const portfolioEditorBacktest = () => import( /* webpackChunkName: "portfolioEditorBacktest" */ '@/pages/portfolio-builder/editor/steps/tabs/backtest')
const portfolioEditorRisk = () => import( /* webpackChunkName: "portfolioEditorRisk" */ '@/pages/portfolio-builder/editor/steps/tabs/risk')

//model-portfolio
const portfolioBuilderModelPortfolioDetail = () => import( /* webpackChunkName: "portfolioBuilderModelPortfolioDetail" */ '@/pages/portfolio-builder/model-portfolio-detail')
const portfolioBuilderModelPortfolioDetailInvestment = () => import( /* webpackChunkName: "portfolioBuilderModelPortfolioInvestment" */ '@/pages/portfolio-builder/model-portfolio-detail/investment')
const portfolioBuilderModelPortfolioDetailRepartition = () => import( /* webpackChunkName: "portfolioBuilderModelPortfolioRepartition" */ '@/pages/portfolio-builder/model-portfolio-detail/repartition')
const portfolioBuilderModelPortfolioDetailEsg = () => import( /* webpackChunkName: "portfolioBuilderModelPortfolioEsg" */ '@/pages/portfolio-builder/model-portfolio-detail/esg')
const portfolioBuilderModelPortfolioDetailBacktest = () => import( /* webpackChunkName: "portfolioBuilderModelPortfolioBacktest" */ '@/pages/portfolio-builder/model-portfolio-detail/backtest')
const portfolioBuilderModelPortfolioDetailContract = () => import( /* webpackChunkName: "portfolioBuilderModelPortfolioContract" */ '@/pages/portfolio-builder/model-portfolio-detail/contract')

// pdf
const managedPortfolioReportingPdf = () => import(/* webpackChunkName: "managedPortfolioReporting" */ '@/pages/pdfs/managed-portfolio-reporting/managed-portfolio-reporting')

// Errors
const error500 = () => import(/* webpackChunkName: "error500" */ '@/pages/errors/500')
const error404 = () => import(/* webpackChunkName: "error404" */ '@/pages/errors/404')
const maintenance = () => import(/* webpackChunkName: "maintenance" */ '@/pages/errors/maintenance')

const hiddenPage = () => import(/* webpackChunkName: "hiddenPage" */ '@/pages/hidden-page')

const pages = {
  hiddenPage,
  loginCABPPage,
  loginKeycloakPage,
  loginKeycloakCallbackPage,
  smsVerification,
  loginDefaultPage,
  loginCabpAuth,
  cgu,
  authenticatedPage,
  lobbyContainer,
  dashboardPage,
  holdingsDashboard,
  dashboardContracts,
  loansDashboard,
  adviceDiscoverLanding,
  adviceDashboard,
  advisedManagement,
  arbitration,
  dashboardLoansContracts,
  advisorAppointmentScheduling,
  contractPage,
  contractOverview,
  contractProject,
  contractAllocation,
  contractInvestments,
  contractPerformance,
  contractSettings,
  contractMyProduct,
  contractDetails,
  contractDocuments,
  contractInformations,
  contractInfoNeeded,
  realestatePage,
  deleteProfile,
  analysePage,
  analyseAllocation,
  analysePerf,
  analyseRisk,
  analyseFees,
  analyseAdvices,
  arbitrationPage,
  arbitrationStart,
  arbitrationMarket,
  arbitrationOptimize,
  arbitrationDetails,
  userPage,
  userProfile,
  userHoldings,
  userDocuments,
  userAllDocuments,
  userAllArbitrations,
  userAllManagementReport,
  userAllCgu,
  userAdvisor,
  userNotifications,
  registerPage,
  subscriptionPage,
  paymentPage,
  accountsAdd,
  accountsAddIndex,
  accountsAddForm,
  accountsAddWebView,
  accountWebauthRedirect,
  accountsNewList,
  accountsUpdateCredentials,
  accountsLoad,
  realEstateFormAddNew,
  realEstateEvaluate,
  realEstateSettings,
  fundOverview,
  fundInvestment,
  fundTransaction,
  profileFill,
  profileFillRisk,
  profileFillInfos,
  profileResult,
  accountsRisk,
  clubLayout,
  ClubLanding,
  clubSubscription,
  clubDashboard,
  ClubPortfolios,
  ClubSettings,
  ClubUnsubscribe,
  clubPriceSelection,
  ClubPortfoliosSelection,
  ClubPaymentInfos,
  ClubWaitingAdvisor,
  ClubExitSurvey,
  advisoryPage,
  advisoryCustomers,
  advisoryCustomersList,
  advisoryCustomersAdd,
  advisoryCustomerInfos,
  advisoryArbitrations,
  advisoryProductCustomerArbitrations,
  advisoryCollectiveArbitrationList,
  advisoryCollectiveArbitrationHistory,
  advisoryEsgSettings,
  advisorySupport,
  customerOverview,
  customerCompliance,
  customerPerformances,
  customerArbitrations,
  customerAllocationSteps,
  customerContractAllocation,
  customerVerificationAllocation,
  customerAllocationFund,
  customerAllocationRecomendation,
  customerAllocationRecomendationFundsListModification,
  customerAllocationRecomendationSummary,
  customerAllocationFees,
  customerStockExchangeSteps,
  customerStockExchangeAllocation,
  customerStockExchangeAnalysis,
  customerStockExchangeTargetPortfolio,
  customerStockExchangePortfolioPerformance,
  customerEstateSteps,
  customerDefinitionAvailableSavings,
  customerInterEnvelopeReallocation,
  customerEstateFees,
  customerIntraEnvelopeReallocation,
  customerArbitrationListReallocation,
  customerEstateReportPreview,
  customerEstateReportPdf,
  complianceOverview,
  complianceRisk,
  complianceEsg,
  complianceDocuments,
  advisoryArbitrationPerformanceCalculation,
  advisoryArbitrationPdf,
  advisoryArbitrationPdfPreview,
  customerInteractions,
  customerMissions,
  advisoryMissionsLayout,
  advisoryMissionsFinancials,
  advisoryMissionsWizard,
  advisoryMissionsDetails,
  advisoryStatsLayout,
  advisoryStatsDashboard,
  portfolioBuilderPage,
  portfolioBuilderContracts,
  portfolioBuilderProductDetails,
  portfolioBuilderProductFondsUniverse,
  portfolioBuilderProductModelPortfolios,
  portfolioBuilderModelPortfolioPdf,
  portfolioBuilderModelPortfolioDetail,
  portfolioBuilderModelPortfolioDetailInvestment,
  portfolioBuilderModelPortfolioDetailRepartition,
  portfolioBuilderModelPortfolioDetailEsg,
  portfolioBuilderModelPortfolioDetailBacktest,
  portfolioBuilderModelPortfolioDetailContract,
  portfolioEditor,
  portfolioEditorStepPortfolio,
  portfolioEditorStepConfirmation,
  portfolioEditorModelPortfolio,
  portfolioEditorAllocation,
  portfolioEditorEsg,
  portfolioEditorBacktest,
  portfolioEditorRisk,
  multiArbitrationOnefundPage,
  multiArbitrationConvergencePage,
  multiArbitrationStep,
  multiArbitrationModelPortfolio,
  multiArbitrationModelPortfolioInvestment,
  multiArbitrationModelPortfolioRepartition,
  multiArbitrationModelPortfolioBacktest,
  multiArbitrationModelPortfolioESG,
  multiArbitrationDisinvestStep,
  multiArbitrationInvestStep,
  multiArbitrationContractStep,
  multiArbitrationPerimeterArbitrated,
  multiArbitrationOutPerimeter,
  contractOrders,
  contractJustifications,
  multiArbitrationComplianceStep,
  multiArbitrationVerificationStep,
  multiArbitrationFeesStep,
  customerClub,
  fundPage,
  managedPortfolioReportingPdf,
  error500,
  error404,
  maintenance,
  loading,
  productCustomerDetails,
  productCustomerCustomer, 
  productCustomerInvest,
  productCustomerRepartition,
  productCustomerEsg,
  productCustomerUnivers,
  welcomePage,
}

export default pages
